import { render, staticRenderFns } from "./InHouseRepairsIndex.vue?vue&type=template&id=ac946392&scoped=true&"
import script from "./InHouseRepairsIndex.vue?vue&type=script&lang=js&"
export * from "./InHouseRepairsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac946392",
  null
  
)

export default component.exports